import { FLOW_STATUSES, type JobStatus } from "@workcost/shared";
import type { BadgeTone } from "../components/Badge";
import type { I18nKey } from "../i18n";

/** สถานะใน shared (ตัวพิมพ์ใหญ่) เป็น key ข้อความของ design (st.*) */
const KEY: Record<JobStatus, I18nKey> = {
  ESTIMATED: "st.estimated",
  QUOTED: "st.quoted",
  APPROVED: "st.approved",
  PREPARING: "st.preparing",
  IN_PROGRESS: "st.inProgress",
  INSPECTION: "st.inspection",
  COMPLETED: "st.done",
  ON_HOLD: "st.paused",
  REJECTED: "st.rejected",
  CANCELLED: "st.cancelled",
};

const TONE: Record<JobStatus, BadgeTone> = {
  ESTIMATED: "info",
  QUOTED: "primary",
  APPROVED: "success",
  PREPARING: "warning",
  IN_PROGRESS: "primary",
  INSPECTION: "info",
  COMPLETED: "success",
  ON_HOLD: "warning",
  CANCELLED: "danger",
  REJECTED: "danger",
};

export const statusKey = (s: JobStatus): I18nKey => KEY[s];
export const statusTone = (s: JobStatus): BadgeTone => TONE[s];

/** สถานะที่แสดงเป็นงานหยุด (การ์ดจางลง) */
export const isHalted = (s: JobStatus): boolean => s === "ON_HOLD" || s === "CANCELLED" || s === "REJECTED";

/** ตัวกรอง "กำลังทำ" ตาม design */
export const ACTIVE_STATUSES: readonly JobStatus[] = ["APPROVED", "PREPARING", "IN_PROGRESS", "INSPECTION"];

export const FLOW_ORDER: readonly JobStatus[] = FLOW_STATUSES;
